
// import React, { useState, useRef, useEffect } from 'react';
// import './DMCPackageCreator.css';
// import "../../Supplier/HolidayDashboard.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//     faCloudUploadAlt, faFilePdf, faCheckCircle, faSave, faMapMarkerAlt, faImage, faExclamationCircle 
// } from '@fortawesome/free-solid-svg-icons';
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import { useNavigate, useLocation } from "react-router-dom";
// import Header from '../../Common/Layout/Header';
// import DMCPackageTab from '../../Components/AllTabs/DMCPackageTab';


// const DMCPackagePDFCreator = () => {
//     const { user } = useAuth();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const editId = queryParams.get("id");
//     const isEditMode = !!editId;

//     const [sidebarOpen, setSidebarOpen] = useState(false);
//     const [btnLoading, setBtnLoading] = useState(false);
//     const [filePreview, setFilePreview] = useState({ name: '', type: '', url: '' });
//     const [errors, setErrors] = useState({}); // --- ADDED ERROR STATE ---
//     const fileInputRef = useRef(null);
//      const [rawPdfFile, setRawPdfFile] = useState(null);

//     const [packageData, setPackageData] = useState({
//         id: "00000000-0000-0000-0000-000000000000",
//         companyId: user?.cid,
//         title: '',
//         location: '', 
//         media: {
//             images: [],
//             itineraryPdf: null
//         },
//         contentType: 2, // PDF/Flyer type
//         status: 0
//     });

//     const fetchPackage = async () => {
//         if (isEditMode) {
//             setBtnLoading(true);
//             try {
//                 const res = await apiService.getAll(`${config.GETDMCPACKAGEBYID}/${editId}`);
//                 if (res) {
//                     setPackageData({
//                         ...res,
//                         location: res.destinations?.[0]?.countryName || ''
//                     });
//                     if (res.media?.itineraryPdf) {
//                         setFilePreview({
//                             name: res.media.itineraryPdf.fileName,
//                             type: 'application/pdf',
//                             url: res.media.itineraryPdf.url
//                         });
//                     }
//                 }
//             } catch (err) {
//                 console.error("Fetch Error:", err);
//             } finally {
//                 setBtnLoading(false);
//             }
//         }
//     };

//     useEffect(() => {
//         fetchPackage();
//     }, [isEditMode, editId]);

//     // --- VALIDATION LOGIC ---
//     // --- VALIDATION LOGIC ---
// const validate = () => {
//     let tempErrors = {};
    
//     // Check Title
//     if (!packageData.title || packageData.title.trim() === "") {
//         tempErrors.title = "Please enter your package title.";
//     }
    
//     // FIX: Check rawPdfFile instead of packageData.media.itineraryPdf
//     // In Create mode, we check if a new file is selected.
//     // In Edit mode, we check if a new file is selected OR if an old one already exists.
//     const hasExistingFile = isEditMode && packageData.media?.itineraryPdf;
//     if (!rawPdfFile && !hasExistingFile) {
//         tempErrors.file = "Please upload a Flyer or PDF file.";
//     }
    
//     setErrors(tempErrors);
//     return Object.keys(tempErrors).length === 0;
// };
//     const handleFileUpload = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         setRawPdfFile(file); // Save the raw file object

//         if (errors.file) setErrors({ ...errors, file: null });

//         const reader = new FileReader();
//         reader.onload = (ev) => {
//             setFilePreview({
//                 name: file.name,
//                 type: file.type,
//                 url: ev.target.result
//             });
//         };
//         reader.readAsDataURL(file);
//     };

// //    const handleSave = async () => {
// //         if (!validate()) return; 

// //         setBtnLoading(true);

// //         // 1. Prepare JSON Payload (Minimal data for PDF type)
// //         const payloadObject = {
// //             id: packageData.id || "00000000-0000-0000-0000-000000000000",
// //             companyId: user?.cid,
// //             title: packageData.title,
// //             description: "PDF Flyer Package",
// //             destinations: [{ 
// //                 countryName: packageData.location || "Multiple", 
// //                 countryCode: "TBD", 
// //                 places: [] 
// //             }],
// //             itinerary: [],
// //             pricing: null,
// //             inclusions: [],
// //             exclusions: [],
// //             validity: { 
// //                 from: new Date().toISOString(), 
// //                 to: new Date(new Date().setMonth(new Date().getMonth() + 6)).toISOString() 
// //             },
// //             contentType: 2, // MediaOnly
// //             status: 0
// //         };

// //         try {
// //             if (isEditMode) {
// //                 // Update usually uses JSON directly
// //                 await apiService.update(`${config.UPDATEDMCPACKAGE}/${payloadObject.id}`, payloadObject);
// //                 alert("Updated successfully");
// //                 await fetchPackage(); 
// //             } else {
// //                 // --- CREATE: USE FORMDATA ---
// //                 const formData = new FormData();
                
// //                 // A. Add JSON String (Key: PackageJson)
// //                 formData.append("PackageJson", JSON.stringify(payloadObject));
                
// //                 // B. Add File (Key: UploadItineraryPdf)
// //                 if (rawPdfFile) {
// //                     formData.append("UploadItineraryPdf", rawPdfFile);
// //                 }

// //                 // Send using apiService.create (Axios handles FormData automatically)
// //                 await apiService.create(config.CREATEDMCPACKAGE, formData);
// //                 navigate("/dmcpackageslist");
// //             }
// //         } catch (error) {
// //             console.error("API Error", error);
// //         } finally {
// //             setBtnLoading(false);
// //         }
// //     };

// const handleSave = async () => {
//         if (!validate()) return; 

//         setBtnLoading(true);

//         // 1. Prepare JSON Payload (Minimal data for PDF type)
//         const payloadObject = {
//             id: packageData.id || "00000000-0000-0000-0000-000000000000",
//             companyId: user?.cid,
//             title: packageData.title,
//             description: "PDF Flyer Package",
//             destinations: [{ 
//                 countryName: packageData.location || "Multiple", 
//                 countryCode: "TBD", 
//                 places: [] 
//             }],
//             itinerary: [],
//             pricing: null,
//             inclusions: [],
//             exclusions: [],
//             validity: { 
//                 from: new Date().toISOString(), 
//                 to: new Date(new Date().setMonth(new Date().getMonth() + 6)).toISOString() 
//             },
//             contentType: 2, // MediaOnly
//             status: 0
//         };

//         try {
//             // --- FIX STARTS HERE ---
            
//             // 1. Create FormData object (Required for File Uploads)
//             const formData = new FormData();
            
//             // 2. Append the JSON data
//             formData.append("PackageJson", JSON.stringify(payloadObject));

//             // 3. Append the File (ONLY if a new file was selected)
//             if (rawPdfFile) {
//                 formData.append("UploadItineraryPdf", rawPdfFile);
//             }

//             if (isEditMode) {
//                 // UPDATE: Send 'formData', NOT 'payloadObject'
//                 await apiService.update(`${config.UPDATEDMCPACKAGE}/${payloadObject.id}`, formData);
//                 alert("Updated successfully");
//                 await fetchPackage(); 
//             } else {
//                 // CREATE: Already correct, using formData
//                 await apiService.create(config.CREATEDMCPACKAGE, formData);
//                 navigate("/dmcpackageslist");
//             }

//             // --- FIX ENDS HERE ---

//         } catch (error) {
//             console.error("API Error", error);
//         } finally {
//             setBtnLoading(false);
//         }
//     };
//     return (
//         <div className="layout-wrapper">
//             <Header User={user} activeSection="holidays" />
//             <div className="p-2">
//                 <DMCPackageTab pageName="DMCPACKAGECREATE" />
//             </div>
//             <div className="holidaydashboard-dashboard">
//                 <main className="holidaydashboard-main-content">
//                     <div className="dmc-pkg-main-wrapper">
//                         <div className="dmc-pkg-form-container">
//                             <div className="dmc-pkg-tabs mb-4">
//                                 <button className="dmc-pkg-tab-link" onClick={() => navigate('/dmcpackagecreate')}>Manual Entry</button>
//                                 <button className="dmc-pkg-tab-link is-active">Upload PDF Only</button>
//                             </div>
//                             <div className="dmc-pkg-card">
//                                 <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
//                                     <h2 className="dmc-pkg-section-title mb-0">
//                                         {isEditMode ? "Update PDF Package" : "Create PDF Package"}
//                                     </h2>
//                                     <button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleSave} disabled={btnLoading}>
//                                         {btnLoading ? "Processing..." : <><FontAwesomeIcon icon={faSave} /> {isEditMode ? "Update Package" : "Create Package"}</>}
//                                     </button>
//                                 </div>

//                                 <div className="dmc-pkg-form-body">
//                                     <div className="mb-4">
//                                         <h4 style={{color: '#0f766e', fontWeight: 700, fontSize: '16px'}}>Quick Upload</h4>
//                                         <p className="text-muted" style={{fontSize: '13px'}}>Upload your flyer or PDF directly. Agents will view this file instead of a digital itinerary.</p>
//                                     </div>

//                                     <div className="dmc-pkg-field-group">
//                                         <label className="dmc-pkg-label">Package Title *</label>
//                                         <input 
//                                             className={`dmc-pkg-input ${errors.title ? 'dmc-is-invalid' : ''}`} 
//                                             placeholder="e.g. Amazing Dubai 5 Days Flyer" 
//                                             value={packageData.title}
//                                             onChange={(e) => {
//                                                 setPackageData({...packageData, title: e.target.value});
//                                                 if (errors.title) setErrors({...errors, title: null});
//                                             }}
//                                         />
//                                         {errors.title && <div className="dmc-error-message mt-1"><FontAwesomeIcon icon={faExclamationCircle} /> {errors.title}</div>}
//                                     </div>

//                                     <div className="dmc-pkg-field-group">
//                                         <label className="dmc-pkg-label">Flyer / PDF File *</label>
//                                         <div 
//                                             className={`dmc-pdf-upload-area ${errors.file ? 'border-danger' : ''}`} 
//                                             style={{ borderColor: errors.file ? '#ef4444' : '' }}
//                                             onClick={() => fileInputRef.current.click()}
//                                         >
//                                             <input type="file" ref={fileInputRef} hidden accept=".pdf,image/*" onChange={handleFileUpload} />
//                                             <div className="text-center">
//                                                 <FontAwesomeIcon icon={filePreview.name ? faCheckCircle : faCloudUploadAlt} size="3x" className="mb-3" style={{color: filePreview.name ? '#10b981' : (errors.file ? '#ef4444' : '#3b82f6')}} />
//                                                 <h5>{filePreview.name ? filePreview.name : "Click to upload or drag and drop"}</h5>
//                                                 <p className="text-muted small">Supports PDF or Images (JPG/PNG)</p>
//                                             </div>
//                                         </div>
//                                         {errors.file && <div className="dmc-error-message text-center mt-2"><FontAwesomeIcon icon={faExclamationCircle} /> {errors.file}</div>}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* RIGHT SIDE PREVIEW */}
//                         <div className="dmc-pkg-preview-container">
//                             <div className="dmc-pkg-preview-card custom-scrollbar" style={{height: '100%', background: '#fff'}}>
//                                 <div className="dmc-pkg-preview-hero" style={{height: '250px', background: '#f1f5f9'}}>
//                                     <span className="dmc-pkg-direct-tag">{user?.companyname}</span>
                                  
//                                     {filePreview.type.includes('image') ? (
//                                         <img src={filePreview.url} alt="Flyer Preview" className="dmc-pkg-preview-img" />
//                                     ) : (
//                                         <div className="text-center text-muted" style={{paddingTop: '60px'}}>
//                                             <FontAwesomeIcon icon={filePreview.name ? faFilePdf : faCloudUploadAlt} size="4x" style={{color: filePreview.name ? '#ef4444' : '#cbd5e1'}} />
//                                             <p className="mt-2">{filePreview.name || "File Preview"}</p>
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div className="dmc-pkg-preview-details">
//                                     <h1 className="dmc-pkg-preview-title" style={{fontSize: '22px'}}>
//                                         {packageData.title || "Untitled Flyer Package"}
//                                     </h1>
                                    
//                                     <div className="mt-4 p-3" style={{border: '1px dashed #e2e8f0', borderRadius: '8px', textAlign: 'center'}}>
//                                         {filePreview.name ? (
//                                             <div style={{color: '#0f172a'}}>
//                                                 <FontAwesomeIcon icon={filePreview.type.includes('pdf') ? faFilePdf : faImage} className="me-2" />
//                                                 <span style={{fontWeight: '600'}}>{filePreview.name}</span>
//                                                 <div className="text-muted small mt-1">Ready to Publish</div>
//                                             </div>
//                                         ) : (
//                                             <span className="text-muted small">No file uploaded yet</span>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </main>
//             </div>
//         </div>
//     );
// };

// export default DMCPackagePDFCreator;
import React, { useState, useRef, useEffect } from 'react';
import './DMCPackageCreator.css';
import "../../Supplier/HolidayDashboard.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCloudUploadAlt, faFilePdf, faCheckCircle, faSave, faMapMarkerAlt, faImage, faExclamationCircle, faGlobe, faTimes 
} from '@fortawesome/free-solid-svg-icons';
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import Header from '../../Common/Layout/Header';
import DMCPackageTab from '../../Components/AllTabs/DMCPackageTab';
// --- IMPORT DESTINATION DATA ---
import DESTINATIONPLACES from '../../Data/DestinationPlaces.json';

const DMCPackagePDFCreator = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const editId = queryParams.get("id");
    const isEditMode = !!editId;

    const [btnLoading, setBtnLoading] = useState(false);
    const [filePreview, setFilePreview] = useState({ name: '', type: '', url: '' });
    const [errors, setErrors] = useState({});
    const fileInputRef = useRef(null);
    const [rawPdfFile, setRawPdfFile] = useState(null);

    // --- SEARCH STATES ---
    const [destSearchTerm, setDestSearchTerm] = useState("");
    const [showDestDropdown, setShowDestDropdown] = useState(false);

    const [packageData, setPackageData] = useState({
        id: "00000000-0000-0000-0000-000000000000",
        companyId: user?.cid,
        title: '',
        destinations: [], 
        media: {
            images: [],
            itineraryPdf: null
        },
        contentType: 2, 
        status: 0
    });

    const fetchPackage = async () => {
        if (isEditMode) {
            setBtnLoading(true);
            try {
                const res = await apiService.getAll(`${config.GETDMCPACKAGEBYID}/${editId}`);
                if (res) {
                    setPackageData({
                        ...res,
                        destinations: res.destinations || [] 
                    });
                    if (res.media?.itineraryPdf) {
                        setFilePreview({
                            name: res.media.itineraryPdf.fileName,
                            type: 'application/pdf',
                            url: res.media.itineraryPdf.url
                        });
                    }
                }
            } catch (err) {
                console.error("Fetch Error:", err);
            } finally {
                setBtnLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchPackage();
    }, [isEditMode, editId]);

    // --- UPDATED: HANDLE ADDING COUNTRY OR PLACE ---
    const addDestination = (item, type) => {
        setPackageData(prev => {
            const dests = [...prev.destinations];
            
            if (type === 'country') {
                // User clicked a Country (e.g. India)
                // Only add if it doesn't exist
                if (!dests.some(d => d.countryCode === item.destinationId)) {
                    dests.push({
                        countryName: item.destination,
                        countryCode: item.destinationId,
                        places: [] 
                    });
                }
            } else {
                // User clicked a Place (e.g. Dubai)
                // 1. Identify Parent Country
                const countryCode = item.parentId;
                const countryName = item.parentName;
                const placeObj = { cityCode: item.placeId, cityName: item.placeName };

                // 2. Check if Country already in list
                const existingIndex = dests.findIndex(d => d.countryCode === countryCode);

                if (existingIndex > -1) {
                    // Country exists -> Add place if not present
                    const currentPlaces = dests[existingIndex].places || [];
                    if (!currentPlaces.some(p => p.cityCode === placeObj.cityCode)) {
                        dests[existingIndex].places.push(placeObj);
                    }
                } else {
                    // Country doesn't exist -> Add Country + Place
                    dests.push({
                        countryName: countryName,
                        countryCode: countryCode,
                        places: [placeObj]
                    });
                }
            }
            return { ...prev, destinations: dests };
        });
        
        setDestSearchTerm("");
        setShowDestDropdown(false);
        if (errors.destinations) setErrors({ ...errors, destinations: null });
    };

    const removeDestination = (idx) => {
        setPackageData(prev => ({
            ...prev,
            destinations: prev.destinations.filter((_, i) => i !== idx)
        }));
    };

    const validate = () => {
        let tempErrors = {};
        if (!packageData.title || packageData.title.trim() === "") tempErrors.title = "Please enter your package title.";
        if (packageData.destinations.length === 0) tempErrors.destinations = "Please select at least one destination.";
        
        const hasExistingFile = isEditMode && packageData.media?.itineraryPdf;
        if (!rawPdfFile && !hasExistingFile) tempErrors.file = "Please upload a Flyer or PDF file.";
        
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setRawPdfFile(file); 
        if (errors.file) setErrors({ ...errors, file: null });

        const reader = new FileReader();
        reader.onload = (ev) => {
            setFilePreview({
                name: file.name,
                type: file.type,
                url: ev.target.result
            });
        };
        reader.readAsDataURL(file);
    };

    const handleSave = async () => {
        if (!validate()) return; 

        setBtnLoading(true);

        const payloadObject = {
            id: packageData.id || "00000000-0000-0000-0000-000000000000",
            companyId: user?.cid,
            title: packageData.title,
            description: "PDF Flyer Package",
            destinations: packageData.destinations, // Sends full structure (Country + Places)
            itinerary: [],
            pricing: null,
            inclusions: [],
            exclusions: [],
            validity: { 
                from: new Date().toISOString(), 
                to: new Date(new Date().setMonth(new Date().getMonth() + 6)).toISOString() 
            },
            contentType: 2, 
            status: 0
        };

        try {
            const formData = new FormData();
            formData.append("PackageJson", JSON.stringify(payloadObject));
            
            if (rawPdfFile) {
                formData.append("UploadItineraryPdf", rawPdfFile);
            }

            if (isEditMode) {
                await apiService.update(`${config.UPDATEDMCPACKAGE}/${payloadObject.id}`, formData);
                
                await fetchPackage(); 
            } else {
                await apiService.create(config.CREATEDMCPACKAGE, formData);
                navigate("/dmcpackageslist");
            }
        } catch (error) {
            console.error("API Error", error);
        } finally {
            setBtnLoading(false);
        }
    };

    return (
        <div className="layout-wrapper">
            <Header User={user} activeSection="holidays" />
            <div className="p-2">
                <DMCPackageTab pageName="DMCPACKAGECREATE" />
            </div>
            <div className="holidaydashboard-dashboard">
                <main className="holidaydashboard-main-content">
                    <div className="dmc-pkg-main-wrapper">
                        <div className="dmc-pkg-form-container">
                            <div className="dmc-pkg-tabs mb-4">
                                <button className="dmc-pkg-tab-link" onClick={() => navigate('/dmcpackagecreate')}>Manual Entry</button>
                                <button className="dmc-pkg-tab-link is-active">Upload PDF Only</button>
                            </div>
                            <div className="dmc-pkg-card">
                                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                    <h2 className="dmc-pkg-section-title mb-0">
                                        {isEditMode ? "Update PDF Package" : "Create PDF Package"}
                                    </h2>
                                    <button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleSave} disabled={btnLoading}>
                                        {btnLoading ? "Processing..." : <><FontAwesomeIcon icon={faSave} /> {isEditMode ? "Update Package" : "Create Package"}</>}
                                    </button>
                                </div>

                                <div className="dmc-pkg-form-body">
                                    <div className="mb-4">
                                        <h4 style={{color: '#0f766e', fontWeight: 700, fontSize: '16px'}}>Quick Upload</h4>
                                        <p className="text-muted" style={{fontSize: '13px'}}>Upload your flyer or PDF directly. Agents will view this file instead of a digital itinerary.</p>
                                    </div>

                                    <div className="dmc-pkg-field-group">
                                        <label className="dmc-pkg-label">Package Title *</label>
                                        <input 
                                            className={`dmc-pkg-input ${errors.title ? 'dmc-is-invalid' : ''}`} 
                                            placeholder="e.g. Amazing Dubai 5 Days Flyer" 
                                            value={packageData.title}
                                            onChange={(e) => {
                                                setPackageData({...packageData, title: e.target.value});
                                                if (errors.title) setErrors({...errors, title: null});
                                            }}
                                        />
                                        {errors.title && <div className="dmc-error-message mt-1"><FontAwesomeIcon icon={faExclamationCircle} /> {errors.title}</div>}
                                    </div>

                                    {/* --- UPDATED DESTINATION SEARCH --- */}
                                   <div className="dmc-pkg-field-group" style={{position: 'relative'}}>
                                        <label className="dmc-pkg-label">Destination *</label>
                                        
                                        {/* Added style={{width: '100%'}} here */}
                                        <div className="dmc-autocomplete-wrapper" style={{width: '100%'}}>
                                            <input 
                                                className={`dmc-pkg-input ${errors.destinations ? 'dmc-is-invalid' : ''}`} 
                                                // Added style={{width: '100%'}} here as well
                                                style={{width: '100%'}}
                                                placeholder="Search Country (e.g. United Arab Emirates) or Place (e.g. Dubai)" 
                                                value={destSearchTerm}
                                                onChange={(e) => {
                                                    setDestSearchTerm(e.target.value);
                                                    setShowDestDropdown(true);
                                                }}
                                                onFocus={() => setShowDestDropdown(true)}
                                            />
                                            {/* DROPDOWN LOGIC */}
                                            {showDestDropdown && destSearchTerm.length > 0 && (
                                                <ul className="dmc-autocomplete-list">
                                                    
                                                    {/* 1. Countries Matching */}
                                                    {DESTINATIONPLACES
                                                        .filter(item => item.destination.toLowerCase().includes(destSearchTerm.toLowerCase()))
                                                        .slice(0, 5)
                                                        .map(item => (
                                                            <li key={`c-${item.destinationId}`} onClick={() => addDestination(item, 'country')}>
                                                                <FontAwesomeIcon icon={faGlobe} style={{ marginRight: '8px', color: '#64748b' }} />
                                                                {item.destination} <span className="small text-muted">(Country)</span>
                                                            </li>
                                                        ))
                                                    }

                                                    {/* 2. Places Matching */}
                                                    {DESTINATIONPLACES
                                                        .flatMap(country => country.places.map(place => ({ ...place, parentName: country.destination, parentId: country.destinationId })))
                                                        .filter(place => place.placeName.toLowerCase().includes(destSearchTerm.toLowerCase()))
                                                        .slice(0, 8)
                                                        .map(place => (
                                                            <li key={`p-${place.placeId}`} onClick={() => addDestination(place, 'place')}>
                                                                <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: '8px', color: '#ef4444' }} />
                                                                {place.placeName}, {place.parentName}
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            )}
                                        </div>
                                        {errors.destinations && <div className="dmc-error-message mt-1"><FontAwesomeIcon icon={faExclamationCircle} /> {errors.destinations}</div>}
                                        
                                        {/* SELECTED TAGS */}
                                        <div className="dmc-pkg-tag-container" style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                            {packageData.destinations.map((dest, idx) => {
                                                const placesStr = dest.places && dest.places.length > 0 
                                                    ? ` (${dest.places.map(p => p.cityName).join(', ')})` 
                                                    : '';
                                                
                                                return (
                                                    <span key={idx} className="dmc-pkg-tag" style={{background: '#e0f2fe', color: '#0369a1', padding: '5px 10px', borderRadius: '20px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '5px'}}>
                                                        <FontAwesomeIcon icon={faMapMarkerAlt} /> 
                                                        {dest.countryName} 
                                                        <span style={{fontWeight: 'normal', fontStyle: 'italic'}}>{placesStr}</span>
                                                        <FontAwesomeIcon 
                                                            icon={faTimes} 
                                                            style={{cursor: 'pointer', marginLeft: '5px'}} 
                                                            onClick={() => removeDestination(idx)}
                                                        />
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    </div>


                                    <div className="dmc-pkg-field-group">
                                        <label className="dmc-pkg-label">Flyer / PDF File *</label>
                                        <div 
                                            className={`dmc-pdf-upload-area ${errors.file ? 'border-danger' : ''}`} 
                                            style={{ borderColor: errors.file ? '#ef4444' : '' }}
                                            onClick={() => fileInputRef.current.click()}
                                        >
                                            <input type="file" ref={fileInputRef} hidden accept=".pdf,image/*" onChange={handleFileUpload} />
                                            <div className="text-center">
                                                <FontAwesomeIcon icon={filePreview.name ? faCheckCircle : faCloudUploadAlt} size="3x" className="mb-3" style={{color: filePreview.name ? '#10b981' : (errors.file ? '#ef4444' : '#3b82f6')}} />
                                                <h5>{filePreview.name ? filePreview.name : "Click to upload or drag and drop"}</h5>
                                                <p className="text-muted small">Supports PDF or Images (JPG/PNG)</p>
                                            </div>
                                        </div>
                                        {errors.file && <div className="dmc-error-message text-center mt-2"><FontAwesomeIcon icon={faExclamationCircle} /> {errors.file}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDE PREVIEW */}
                        <div className="dmc-pkg-preview-container">
                            <div className="dmc-pkg-preview-card custom-scrollbar" style={{height: '100%', background: '#fff'}}>
                                <div className="dmc-pkg-preview-hero" style={{height: '250px', background: '#f1f5f9'}}>
                                    <span className="dmc-pkg-direct-tag">{user?.companyname}</span>
                                  
                                    {filePreview.type.includes('image') ? (
                                        <img src={filePreview.url} alt="Flyer Preview" className="dmc-pkg-preview-img" />
                                    ) : (
                                        <div className="text-center text-muted" style={{paddingTop: '60px'}}>
                                            <FontAwesomeIcon icon={filePreview.name ? faFilePdf : faCloudUploadAlt} size="4x" style={{color: filePreview.name ? '#ef4444' : '#cbd5e1'}} />
                                            <p className="mt-2">{filePreview.name || "File Preview"}</p>
                                        </div>
                                    )}
                                </div>

                                <div className="dmc-pkg-preview-details">
                                    <h1 className="dmc-pkg-preview-title" style={{fontSize: '22px'}}>
                                        {packageData.title || "Untitled Flyer Package"}
                                    </h1>
                                    
                                    {/* PREVIEW LOCATIONS (Display Country & Places) */}
                                    <div className="mt-2 mb-3">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} style={{color: '#ef4444', marginRight: '5px'}}/>
                                        <span className="text-muted">
                                            {packageData.destinations.length > 0 
                                                ? packageData.destinations.map(d => {
                                                    const places = d.places && d.places.length > 0 ? `(${d.places.map(p => p.cityName).join(', ')})` : '';
                                                    return `${d.countryName} ${places}`;
                                                }).join(", ") 
                                                : "No Destination Selected"}
                                        </span>
                                    </div>

                                    <div className="mt-4 p-3" style={{border: '1px dashed #e2e8f0', borderRadius: '8px', textAlign: 'center'}}>
                                        {filePreview.name ? (
                                            <div style={{color: '#0f172a'}}>
                                                <FontAwesomeIcon icon={filePreview.type.includes('pdf') ? faFilePdf : faImage} className="me-2" />
                                                <span style={{fontWeight: '600'}}>{filePreview.name}</span>
                                                <div className="text-muted small mt-1">Ready to Publish</div>
                                            </div>
                                        ) : (
                                            <span className="text-muted small">No file uploaded yet</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default DMCPackagePDFCreator;